import React, { useMemo, useCallback } from 'react';
import './MailMultOperPanel.scss';
import useMailStore from '@web-mail/hooks/useMailStoreRedux';
import { getCheckedMails } from '@web-mail/utils/mail';
import FolderLogo from './FolderLogo';
import useState2RM from '../../hooks/useState2ReduxMock';
import MailMultOperationBtns from './MailMultOperationBtns';
import { getIn18Text } from 'api';
const MailMultOperPanel = () => {
    const [mailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const [searchList] = useMailStore('searchList');
    const [activeIds] = useState2RM('activeIds');
    const [mailDataList] = useMailStore('mailDataList');
    const mailList = isSearching ? searchList : mailDataList;
    const allMailCount = useMemo(() => {
        const checkedMails = getCheckedMails(activeIds, mailList);
        return (checkedMails === null || checkedMails === void 0 ? void 0 : checkedMails.length) || 0;
    }, [activeIds, mailList]);
    const domPropsRender = useCallback((mails, menuConfig) => {
        return {
            'data-test-id': 'mail-menu-multPanel-' + (menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.key),
        };
    }, []);
    return (React.createElement("div", { className: "u-read-wrapper", style: {
            height: '100%',
        } },
        React.createElement("div", { className: "mail-mop-wrap" },
            React.createElement("div", { className: "mop-contetn" },
                React.createElement("div", { className: "detail-wrap" },
                    React.createElement("div", { className: "logo-wrap" },
                        React.createElement(FolderLogo, { sum: allMailCount })),
                    React.createElement("div", { className: "num-wrap" },
                        React.createElement("div", { className: "num" }, allMailCount),
                        React.createElement("div", { className: "tip" }, getIn18Text('YIXUANZEYOUJIAN')))),
                React.createElement(MailMultOperationBtns, { domProps: domPropsRender })))));
};
export default MailMultOperPanel;
